import Header from "../header/Header";
import Footer from "../footer/Footer";
import { getToken } from "../shared/TokenInformation/TokenInformation";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import classes from './AppRoute.module.css';

const AppRoute = (props) => {
    const { Element } = props;
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const isUserLoggedIn = () => {
            const tokenInfo = getToken();
            if (!tokenInfo || tokenInfo === 'undefined') {
                setIsLoggedIn(false);
                navigate('/');
            } else {
                setIsLoggedIn(true);
            }
        };

        isUserLoggedIn();
    }, [navigate]);

    //check permissions here
    return (
        <>
            {isLoggedIn ?
                <>
                    <Header/>
                    <div className={classes.content}>
                        <Element/>
                    </div>
                    <Footer/>
                </>
                :
                null
            }
        </>
    );
}

export default AppRoute;
